import { render, staticRenderFns } from "./product-size.vue?vue&type=template&id=ccdf4512&"
import script from "./product-size.vue?vue&type=script&lang=js&"
export * from "./product-size.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports